export default "__VITE_ASSET__Do_Wl0NB__"